import { ref } from '@vue/composition-api';
import screenfull from 'screenfull';

const isFullScreen = ref(false);
const fullScreenElement = ref(null);

export default function useFullScreen() {
  function fullScreenCheck() {
    if (!fullScreenElement.value) return null;
    return screenfull.request(fullScreenElement.value);
  }

  function requestFullScreen() {
    fullScreenCheck();
    screenfull.on('change', () => {
      isFullScreen.value = screenfull.isFullscreen;
    });
  }

  function exitFullScreen() {
    if (!fullScreenElement.value) return null;
    return screenfull.exit();
  }

  function setFullScreenElement(element) {
    fullScreenElement.value = element;
  }

  return {
    requestFullScreen,
    exitFullScreen,
    isFullScreen,
    setFullScreenElement,
  };
}
